<template>
  <ToolbarContainer>
    <template v-slot:toolbar>
      <TabBar
        class="tabBar"
      >
        <template v-slot:tabs>
          <Tabs
            :activeTab="activeTab"
            :tabs="$options.tabList"
            @selectedTab="handleTabSelected"
          />
        </template>
      </TabBar>
    </template>
    <template v-slot:body>
      <div>
        <PasswordManagerAppVersionItemList
          :key="os"
          :os="os"
        />
      </div>
    </template>
  </ToolbarContainer>
</template>

<script>
import {
  TabBar,
  Tabs,
  ToolbarContainer,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { passwordManagerOS } from 'client/PasswordManager/PasswordManagerConstants';
import PasswordManagerAppVersionItemList from 'client/PasswordManager/Overview/PasswordManagerAppVersionItemList.vue';

const { TabItem } = Types;

const PasswordManagerAppVersionCollection = 'PasswordManagerAppVersionCollection';

const androidTabKey = 'android';
const desktopappTabKey = 'desktopapp';
const iosTabKey = 'ios';

const tabOsMap = {
  [androidTabKey]: passwordManagerOS.android,
  [desktopappTabKey]: passwordManagerOS.desktop,
  [iosTabKey]: passwordManagerOS.ios,
};

const tabList = [
  TabItem({
    label: 'Desktop App',
    key: desktopappTabKey,
  }),
  TabItem({
    label: 'iOS',
    key: iosTabKey,
  }),
  TabItem({
    label: 'Android',
    key: androidTabKey,
  }),
];

export default {
  name: 'PasswordManagerAppVersionsTabs',

  components: {
    PasswordManagerAppVersionItemList,
    TabBar,
    Tabs,
    ToolbarContainer,
  },

  data() {
    return {
      activeTab: 'desktopapp',
    };
  },

  computed: {
    os() {
      return tabOsMap[this.activeTab];
    },
  },

  tabList,

  destroyed() {
    this.resetCollection();
  },

  methods: {
    ...mapActions(PasswordManagerAppVersionCollection, [
      'resetCollection',
    ]),

    handleTabSelected(tabKey) {
      this.activeTab = tabKey;
    },
  },
};
</script>

<style scoped>
.tabBar {
  margin-top: var(--jc-spacer);
  padding: 0 var(--jc-spacer);
}
</style>
